import React, { useEffect, useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { Cards } from '../../components';
import useGetDistributorStatistics, {
  GetDistributorStatisticQueryResult as DistributorResult,
} from '../../hooks/distributors/useGetDistributorStatistics';
import useGetFreightStatistics, {
  GetFreightStatisticQueryResult as FreightResult,
} from '../../hooks/freights/useGetFreightStatistics';
import Charts from '../../components/Charts';
import CardsAdmin from '../../components/CardsAdmin';
import TableCardFreight from '../../components/List/TableCardFreight';
import TableCardDrivers from '../../components/List/TableCardDrivers';
import useGetDriverStatistics, {
  GetDriverStatisticsResponse,
} from '../../hooks/driver/useGetDriverStatistics';
import TableFreightNotAccepted from '../../components/List/TableFreightNotAccepted';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  flexGrid: {
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    flexGrow: 1,
  },
}));

const DashboardAdmin: React.FC = () => {
  const classes = useStyles();
  const { execute: getDistributorStats, loading: loadingDistributor } =
    useGetDistributorStatistics();
  const { execute: getFreightStats, loading: loadingFreights } =
    useGetFreightStatistics();
  const { execute: getDriverStats, loading: loadingDrivers } =
    useGetDriverStatistics();
  const { execute: getFreightStatistics, loading } = useGetFreightStatistics();

  const [distributorStatistics, setDistributorStatistics] = useState<
    DistributorResult[]
  >([]);
  const [freightStatistics, setFreightStatistics] =
    useState<FreightResult | null>(null);
  const [driverInformation, setDriverInformation] = useState<
    GetDriverStatisticsResponse | undefined
  >();
  const [freightInfo, setFreightInfo] = useState<any>();

  useEffect(() => {
    const fetchData = async () => {
      const [distributorData, freightData, driverData] = await Promise.all([
        getDistributorStats(),
        getFreightStats(),
        getDriverStats(),
      ]);
      setDriverInformation(driverData);
      setDistributorStatistics(distributorData);
      setFreightStatistics(freightData || null);
      setFreightInfo(freightData || null);
    };

    fetchData();
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CardsAdmin data={distributorStatistics} loading={loadingDistributor} />
      </Grid>
      <Grid item xs={12}>
        <Charts data={freightStatistics?.freightPercentageOverTime || []} />
      </Grid>
      <Grid item xs={12}>
        <Cards
          data={freightStatistics?.deliveryTotals}
          loading={loadingFreights || loadingDrivers}
          driverData={driverInformation}
        />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.flexGrid}>
        <TableCardDrivers />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.flexGrid}>
        <TableCardFreight
          data={freightInfo?.distributorAndWaitingTime || []}
          loading={loadingFreights}
        />
      </Grid>
      <Grid item xs={12}>
        <TableFreightNotAccepted
          data={freightStatistics?.freightsAwaitingDriver || []}
          loading={loading}
        />
      </Grid>
    </Grid>
  );
};

export default DashboardAdmin;
